import { Link, useLocation } from "react-router-dom";
import "./Footer.css";
import { useLanguage } from "../i18n";

export default function Footer() {
  const { t } = useLanguage();
  const location = useLocation();

  const legalReturnTo = `${location.pathname}${location.search}${location.hash}`;

  return (
    <footer className="bu-footer">
      <div className="bu-footer-grid">

        {/* LEGAL */}
        <div className="bu-footer-col">
          <h4>{t("legal")}</h4>

          <Link to="/terms" state={{ legalReturnTo }}>
            {t("terms")}
          </Link>

          <Link to="/privacy" state={{ legalReturnTo }}>
            {t("privacy")}
          </Link>

          <Link to="/cookies" state={{ legalReturnTo }}>
            {t("cookiePolicy")}
          </Link>

          <Link to="/legal-notice" state={{ legalReturnTo }}>
            {t("legalNotice")}
          </Link>

          <button
            type="button"
            className="bu-footer-cookie-settings"
            onClick={() => window.dispatchEvent(new Event("bublyup:open-cookie-settings"))}
          >
            {t("cookieSettings")}
          </button>
        </div>

        {/* SUPPORT */}
        <div className="bu-footer-col">
          <h4>{t("support")}</h4>

          <Link to="/support#contact">
            {t("contactSupport")}
          </Link>

          <Link to="/quick-questions">
            {t("quickQuestions")}
          </Link>

          <a
            href="https://wa.me/15717585005"
            target="_blank"
            rel="noreferrer"
          >
            {t("whatsappSupport")}
          </a>

          <Link to="/support#contact">
            {t("feedback")}
          </Link>
        </div>

        {/* COMPANY */}
        <div className="bu-footer-col">
          <h4>{t("company")}</h4>

          <a href="#about">
            {t("about")}
          </a>

          <a href="#team">
            {t("team")}
          </a>

          <a href="#careers">
            {t("careers")}
          </a>
        </div>

      </div>

      {/* PARTNERS */}
      <div className="bu-footer-partners">
        <div className="bu-partner-logos">
          {[
            "logo1.png",
            "logo2.png",
            "logo3.png",
            "logo4.png",
            "logo5.png",
            "logo6.png",
          ].map((logo, index) => (
            <div className="partner-slot" key={index}>
              <img
                src={`/partners/${logo}`}
                alt={`Partner ${index + 1}`}
              />
            </div>
          ))}
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="bu-footer-copy">
        © 2026 BublyUp powered by Desert Shark —{" "}
        {t("allRightsReserved")}
      </div>
    </footer>
  );
}
